import { ClientGroups } from "features/ClientGroups/ClientGroups";
import { Clients } from "features/Clients/Clients";

import styles from "./styles.module.scss";

export const ClientsPage = (): JSX.Element => (
  <div className={styles.main}>
    <ClientGroups />
    <Clients />
  </div>
);
